import { Luscinia, luscinia } from "./luscinia";

luscinia.addCard = function (button) {
    let cardWrapper = $(button).closest(".card-wrapper");
    let parameterFullName = cardWrapper.data("parameter-fullname");
    let columnSize = cardWrapper.data("column-layout") as string;
    let lastCard = cardWrapper.find(".card").last();
    let propertyNamePrefix = cardWrapper.attr("name");
    if (lastCard.length > 0) {
        var counter = extractDigits(lastCard.data("property-prefix"));
        propertyNamePrefix += "-" + (counter + 1);
    }
    else {
        propertyNamePrefix += "-0";
    }
    $.get(`/rendercard/${parameterFullName}/${columnSize}/${propertyNamePrefix}`).done(function (data) {
        let cardContainer = $(button).closest(".card-wrapper").find(".card-container");
        cardContainer.append(data);

        let addedCard = cardContainer.find(".card").last();
        luscinia.initFormElements(addedCard, $(button).closest("form"));

        $(button).closest(".card-wrapper").trigger("change");
    });
}

luscinia.removeCard = function (button) {
    let cards = $(button).closest(".card");
    cards[0].remove();

    $(button).closest(".card-wrapper").trigger("change");
}

export const extractDigits = (str: string): number => {
    const matches = str.match(/\d+/g);
    return matches ? parseInt(matches.join(''), 10) : 0;
};